var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleSwitchedFuseSpurBelowFl01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,3.5V8h4.7C7.5,5.5,5.5,3.6,3,3.5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 8,
    x2: 13,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,8.1c-0.1,2.4-2,4.3-4.4,4.4V8.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSwitchedFuseSpurBelowFl01);
export default __webpack_public_path__ + "static/media/SingleSwitchedFuseSpurBelowFL-01.25d94f07a6d457e5d03a0d8d1eec8ab3.svg";
export { ForwardRef as ReactComponent };